import { useMutation, UseMutationResult } from '@taxdown/zeno-sama-query';
import FeedBackService from 'Services/feedback';
import { history } from 'Store';
import { routes } from 'Constants/routes';
import { FeedBackType, QueryKeys } from 'Types/common';

export const useSaveUserReview = (
  hideModal: () => void
): UseMutationResult<unknown, FeedBackType> =>
  useMutation([QueryKeys.SAVE_REVIEW], FeedBackService.saveFeedback, {
    onSuccess: () => {
      history.push(routes.DASHBOARD);
      hideModal();
    },
  });
